/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdDomainSettingsLauncherDailyBonus
 */
export interface FxIdDomainSettingsLauncherDailyBonus {
    /**
     * Sku of product could be received for free if user logs in daily
     * @type {string}
     * @memberof FxIdDomainSettingsLauncherDailyBonus
     */
    Sku?: string | null;
}

/**
 * Check if a given object implements the FxIdDomainSettingsLauncherDailyBonus interface.
 */
export function instanceOfFxIdDomainSettingsLauncherDailyBonus(value: object): value is FxIdDomainSettingsLauncherDailyBonus {
    return true;
}

export function FxIdDomainSettingsLauncherDailyBonusFromJSON(json: any): FxIdDomainSettingsLauncherDailyBonus {
    return FxIdDomainSettingsLauncherDailyBonusFromJSONTyped(json, false);
}

export function FxIdDomainSettingsLauncherDailyBonusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsLauncherDailyBonus {
    if (json == null) {
        return json;
    }
    return {
        
        'Sku': json['Sku'] == null ? undefined : json['Sku'],
    };
}

export function FxIdDomainSettingsLauncherDailyBonusToJSON(json: any): FxIdDomainSettingsLauncherDailyBonus {
    return FxIdDomainSettingsLauncherDailyBonusToJSONTyped(json, false);
}

export function FxIdDomainSettingsLauncherDailyBonusToJSONTyped(value?: FxIdDomainSettingsLauncherDailyBonus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Sku': value['Sku'],
    };
}

